import { IHierarchyState } from '../states/hierarchy.state'
import * as fromActions from '../actions/hierarchy.action'
import { Reducer } from 'redux'

export const initialState: IHierarchyState = {
  list: [],
  total: 0,
  perPage: 1,
  sort: [],
  loading: false,
}

export const reducer: Reducer<IHierarchyState> = (
  state: IHierarchyState = initialState,
  { type, payload }
) => {
  switch (type) {
    case fromActions.HIERARCHY_LIST_GET:
      return {
        ...state,
        loading: true,
      }
    case fromActions.HIERARCHY_LIST_SUCCESS: {
      const { data: list, total, perPage, sort } = payload
      return {
        ...state,
        list,
        total,
        perPage,
        sort,
        loading: false,
      }
    }
    default:
      return state
  }
}
